<template>
  <b-modal v-model="visible" :title="actualTitle" centered :size="size" :hide-footer="true" @hidden="modalHidden()" :no-close-on-backdrop="true">
    <slot :close="closeModal" :data="data" :visible="visible" :setTitle="setTitle" :cancel="cancelModal"></slot>
  </b-modal>
</template>

<script>
  export default {
    name: "Modal",
    props: {
      size: {
        type: String,
        default: 'lg'
      },
      title: {
        type: String,
        default: 'Modaali tiitel'
      }
    },
    data() {
      return {
        visible: false,
        data: null,
        actualTitle: ''
      }
    },
    created() {
      this.setTitle(this.title)
    },
    methods: {
      setTitle(value) {
        this.actualTitle = value
      },
      show(data) {
        this.data = data
        this.visible = true
      },
      modalHidden() {
        this.data = null
      },
      closeModal(data) {
        this.visible = false
        this.$emit('ok', data)
      },
      cancelModal() {
        this.visible = false
      }
    },
  }
</script>

<style scoped>

</style>
